import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
const SvgCircle = (props, ref) => (_jsx("svg", Object.assign({}, props, { viewBox: "0 0 2134 2134", xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", style: {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 2,
    }, ref: ref }, { children: _jsx("path", { d: "M1066.67 33.333c-570.696 0-1033.33 462.638-1033.33 1033.33 0 570.695 462.638 1033.33 1033.33 1033.33 570.696 0 1033.33-462.638 1033.33-1033.33 0-570.696-462.638-1033.33-1033.33-1033.33Zm0 1933.33c-494.434 0-900-400.229-900-900 0-494.429 400.229-900 900-900 494.433 0 900 400.229 900 900 0 494.429-400.229 900-900 900Z", style: {
            fillRule: 'nonzero',
        } }, void 0) }), void 0));
const ForwardRef = forwardRef(SvgCircle);
const Memo = memo(ForwardRef);
export default Memo;
//# sourceMappingURL=Circle.js.map